import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

import { useLanguage } from '../../../i18n/LanguageContext';

const CustomizationPanel = ({
  settings,
  onSettingsChange,
  onGenerateQR
}) => {
  const { t } = useLanguage();

  const colorOptions = [
    { value: 'primary', label: 'Primary Brown' },
    { value: 'secondary', label: 'Slate Gray' },
    { value: 'accent', label: 'Coral Orange' },
    { value: 'black', label: 'Classic Black' }
  ];

  const handleInputChange = (field, value) => {
    onSettingsChange({ ...settings, [field]: value });
  };

  return (
    <div className="customization-panel bg-card rounded-xl p-6 md:p-8 shadow-warm-lg transition-smooth">
      <div className="panel-header mb-6 md:mb-8">
        <div className="flex items-center space-x-3 mb-2">
          <div className="bg-accent/10 p-2 rounded-lg">
            <Icon name="Settings" size={24} color="var(--color-accent)" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
            {t('customizeQRCode')}
          </h2>
        </div>
        <p className="text-sm md:text-base text-muted-foreground font-caption">
          {t('personalizeQRDesc')}
        </p>
      </div>
      <div className="customization-form space-y-6">
        <div className="form-section">
          <h3 className="text-base md:text-lg font-heading font-medium text-foreground mb-4">
            {t('basicInformation')}
          </h3>
          <div className="space-y-4">
            <Input
              label={t('restaurantNameLabel')}
              type="text"
              placeholder={t('restaurantNamePlaceholder')}
              value={settings?.restaurantName}
              onChange={(e) => handleInputChange('restaurantName', e?.target?.value)}
              required
            />
            <Input
              label={t('menuUrlLabel')}
              type="url"
              placeholder={t('menuUrlPlaceholder')}
              value={settings?.menuUrl}
              onChange={(e) => handleInputChange('menuUrl', e?.target?.value)}
              description={t('menuUrlDesc')}
              required
            />
          </div>
        </div>

        <div className="form-section">
          <h3 className="text-base md:text-lg font-heading font-medium text-foreground mb-4">
            {t('designOptions')}
          </h3>
          <div className="space-y-4">
            <Select
              label={t('qrCodeColor')}
              options={colorOptions}
              value={settings?.color}
              onChange={(value) => handleInputChange('color', value)}
            />
            <Checkbox
              label={t('includeRestaurantLogo')}
              description={t('includeRestaurantLogoDesc')}
              checked={settings?.includeLogo}
              onChange={(e) => handleInputChange('includeLogo', e?.target?.checked)}
            />
            <Checkbox
              label={t('addBorder')}
              description={t('addBorderDesc')}
              checked={settings?.addBorder}
              onChange={(e) => handleInputChange('addBorder', e?.target?.checked)}
            />
          </div>
        </div>

        <div className="form-section">
          <h3 className="text-base md:text-lg font-heading font-medium text-foreground mb-4">
            {t('campaignSettings')}
          </h3>
          <div className="space-y-4">
            <Input
              label={t('promotionalMessage')}
              type="text"
              placeholder={t('promotionalMessagePlaceholder')}
              value={settings?.promoMessage}
              onChange={(e) => handleInputChange('promoMessage', e?.target?.value)}
            />
            <Input
              label={t('expirationDate')}
              type="date"
              value={settings?.expirationDate}
              onChange={(e) => handleInputChange('expirationDate', e?.target?.value)}
              description={t('expirationDateDesc')}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default CustomizationPanel;